<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Transactions</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Transactions
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>Driver Transactions</h4>
                </div>

                <div class="card-body">
                    <div class="search-container">
                        <div class="row">
                            <div class="col-lg-9 col-md-8 col-sm-6 d-flex align-items-center">
                                <img src="/images/search.svg" alt="">
                            </div>

                            <div class="col-lg-3 col-md-4 col-sm-6 d-flex">
                            </div>
                        </div>

                    </div>

                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        @on-page-change="onPageChange"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allTransactions"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                            <span v-else-if="props.column.field === 'id'">
                                <a href="#">{{ props.row.id }}</a>
                            </span>
                            <span v-else-if="props.column.label === 'Name'">
                               <a :href="route('admin.trips.show', props.row.id)">{{
                                       props.row.first_name + ' ' + props.row.last_name
                                   }}</a>
                            </span>
                            <!--                            <span v-else-if="props.column.field === 'status'" class="badge badge-glow"-->
                            <!--                                  :class="props.row.verified ? 'badge-success' : 'badge-danger'">-->
                            <!--                                {{ props.row.verified ? 'Verified' : 'Not Verified' }}-->
                            <!--                            </span>-->
                            <span v-else-if="props.column.field === 'action'">
<!--                                <a :href="`/admin/admins/${props.row.id}/edit`">-->
                                <!--                                    <i class="feather icon-edit"></i> edit-->
                                <!--                                </a> |-->
                                <!--                                <a href="#" class="text-danger">-->
                                <!--                                    <i class="feather icon-trash-2"></i>-->
                                <!--                                    delete-->
                                <!--                                </a>-->
                            </span>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';

export default {
    metaInfo: {title: 'Transactions'},
    props: ['transactions'],
    name: "DriverTransactionIndex",
    layout: Layout,

    data: () => ({
        filter: {},
        isLoadingFilter: false,
        allTransactions: [],
        totalRecords: 0,
        serverParams: {
            page: 1,
            perPage: 10
        },
        paginationOptions: {
            enabled: true,
            mode: 'pages',
            perPage: 10,
            perPageDropdown: [5, 10, 20, 50, 100, 200],
            dropdownAllowAll: false,
        },
        columns: [
            {label: 'S/N', field: 'sn'},
            {label: 'Driver', field: 'driver_name'},
            {label: 'Pickup Address', field: 'pickup_address'},
            {label: 'Drop Address', field: 'drop_address'},
            {label: 'Total Ride Fare', field: 'price'},
            {label: 'Admin Fare', field: 'admin_fee'},
            // {label: 'Action', field: 'action', sortable: false},
        ],
        tableDataLoading: false,
    }),
    created() {
        this.allTransactions = this.transactions.data
        this.totalRecords = this.transactions.total
    },
    methods: {
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({page: params.currentPage});
            this.paginatedData();
        },
        onPerPageChange(params) {
            this.updateParams({perPage: params.currentPerPage});
            this.paginatedData();
        },
        onSortChange(params) {
            this.serverParams.sort = {
                type: params[0].type,
                field: params[0].field,
            }
            this.paginatedData();
        },
        async paginatedData() {
            try {
                let routeName = 'admin.transaction.paginate';

                let {data: {data: {transactions}}} = await axios.post(route(routeName),
                    {...this.serverParams});

                this.totalRecords = transactions.total;
                this.paginationOptions.perPage = transactions.per_page;
                this.post = transactions.data
            } catch (e) {
                console.log(e);
            }
        },

        serialNo(props) {
            return this.serverParams.page === 1 ? props.index + 1 : (this.serverParams.perPage *
                    (this.serverParams.page - 1)) +
                props.index + 1
        },
    }
}
</script>
